import { render, staticRenderFns } from "./IdentityAuth.vue?vue&type=template&id=aa82e918&scoped=true&"
import script from "./IdentityAuth.vue?vue&type=script&lang=js&"
export * from "./IdentityAuth.vue?vue&type=script&lang=js&"
import style0 from "./IdentityAuth.vue?vue&type=style&index=0&id=aa82e918&lang=less&scoped=true&"
import style1 from "./IdentityAuth.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa82e918",
  null
  
)

export default component.exports